import PlantingCyclesSelectMobile from './PlantingCyclesSelectMobile';

export default PlantingCyclesSelectMobile;
